export enum Body {
    ALL = "all",
    SUV = "suv",
    SEDAN = "sedan",
    COUPE = "coupe",
    PERFORMANCE = "performance",
    HATCH = "hatch",
}
